import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../services/faq.service';
import {SearchPipe} from '../../components/common/SearchPipe';
import {FaqCategoryService} from '../../services/faq-category.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {FaqCategory} from '../../model/FaqCategory';
import {FaqArticle} from '../../model/faq-article';
import {CommonModule} from "@angular/common";
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {MobileSearchComponent} from "../../components/common/mobile-search/mobile-search.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {BadgeComponent} from "../../components/common/badge/badge.component";
import {MinPipe} from "../../components/common/MinPipe";
import {UrlDecodePipe} from "../../components/common/UrlDecodePipe";
import {SpinnerComponent} from "../../components/common/spinner/spinner.component";

@Component({
    selector: 'app-faq',
    imports: [
        CommonModule,
        BreadcrumbComponent,
        MobileSearchComponent,
        FaIconComponent,
        SearchBarComponent,
        BadgeComponent,
        MinPipe,
        RouterLink,
        UrlDecodePipe,
        SpinnerComponent
    ],
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  error = false;
  load = true;
  search = '';
  allArticles = [];
  articles: FaqArticle[] = [];
  page: number;
  pagesize = 10;
  categories: FaqCategory[];

  selectedCategory;

  constructor(private faqCategoryService: FaqCategoryService,
              private faqService: FaqService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    const selectedCategory = this.route.snapshot.queryParams.category;
    this.search = this.route.snapshot.queryParams.search;

    this.faqCategoryService.getObjects().subscribe(data => {
      this.categories = data;

      this.selectedCategory = this.categories.find(e => e.id === +selectedCategory);

      this.faqService.getObjects().subscribe(d2 => {
        this.load = false;
        this.allArticles = d2;
        this.articles = this.allArticles;
        this.doFilter();
        this.page = this.route.snapshot.queryParams.page ? +this.route.snapshot.queryParams.page : 1;
      }, () => {
        this.error = true;
      });
    });
  }

  getCategoryById(id: number): FaqCategory {
    return this.categories.find(c => +c.categoryId === id);
  }

  selectCategory(category): void {
    if (this.selectedCategory && category.id === this.selectedCategory.id) {
      this.selectedCategory = undefined;
    } else {
      this.selectedCategory = category;
    }
    this.doFilter();
    this.setParams();
  }

  doSearch(): void {
    this.setParams();
    this.doFilter();
  }

  mobileSearch(event): void {
    this.page = 1;
    this.search = event;
    this.doSearch();
  }

  doFilter(): void {
    this.page = 1;
    if (!this.selectedCategory) {
      this.articles = this.allArticles;
    } else {
      this.articles = this.allArticles.filter(article => {
        return article.categories.indexOf(this.selectedCategory.categoryId) !== -1;
      });
    }

    if (this.search) {
      this.articles = new SearchPipe().transform(this.articles, this.search);
    }
  }

  setParams(): void {
    this.router.navigate([], {
      queryParams: {
        category: this.selectedCategory ? this.selectedCategory.id : null,
        page: this.page,
        search: this.search
      }
    });
  }

  loadParams(): void {
    this.selectedCategory = this.route.snapshot.queryParams.category;
    this.page = this.route.snapshot.queryParams.page ? +this.route.snapshot.queryParams.page : 1;
    this.search = this.route.snapshot.queryParams.search;
  }

  nextPage(): void {
    if (this.page < this.articles.length / this.pagesize) {
      this.page++;
      this.setParams();
    }
  }

  previousPage(): void {
    if (this.page > 1) {
      this.page--;
      this.setParams();
    }
  }
}
